export enum EMealprepDialogMode {
	NORMAL = 'normal',
	PRESELECTED = 'preselected',
}

export enum EMealprepTabs {
	CLIENT_INFO = 'client_info',
	INGRIDIENTS_AND_VARIANTS = 'ingridients_and_variants',
	MEALPREP_REVIEWS = 'mealprep_reviews',
	EDIT_HISTORY = 'edit_history',
	PRODUCTION_STEPS = 'production_steps',
}

export enum EMealPrepPortions {
	ALL = 'all',
	ONE_PORTION = 'serving1',
	TWO_PORTIONS = 'serving2',
	THREE_PORTIONS = 'serving3',
	FOUR_PORTIONS = 'serving4',
	FIVE_PORTIONS = 'serving5',
	SIX_PORTIONS = 'serving6',
}

export enum EMealprepPortionsWithoutAll {
	ONE_PORTION = 'serving1',
	TWO_PORTIONS = 'serving2',
	THREE_PORTIONS = 'serving3',
	FOUR_PORTIONS = 'serving4',
	FIVE_PORTIONS = 'serving5',
	SIX_PORTIONS = 'serving6',
}

export const MealprepPortionsMap: Record<EMealPrepPortions, string> = {
	[EMealPrepPortions.ALL]: 'Wszystkie',
	[EMealPrepPortions.ONE_PORTION]: '1 porcja',
	[EMealPrepPortions.TWO_PORTIONS]: '2 porcje',
	[EMealPrepPortions.THREE_PORTIONS]: '3 porcje',
	[EMealPrepPortions.FOUR_PORTIONS]: '4 porcje',
	[EMealPrepPortions.FIVE_PORTIONS]: '5 porcji',
	[EMealPrepPortions.SIX_PORTIONS]: '6 porcji',
}
